
import { useSelector,useDispatch } from 'react-redux'
import ReferenceMaterialUpload from './ReferenceMaterialUpload';
import TranslationMemorySelection from './TranslationMemorySelection';
import { useEffect, useState } from 'react';
import { getAxiosResponse } from '../../services/authApiRoutes/APImethods';
import APIUrls from '../../services/APIUrls';
import {updateSourceLanguage } from '../../redux/reducers/CreateProjectSourceLanguageSlice';
import {updateTargetLanguage } from '../../redux/reducers/CreateProjectTargetLanguageSlice';
import { transformBlankToNull } from '../../services/Util';
import Constants from '../../Constants';
import Select from "react-select";
import { useTranslation } from 'react-i18next';
import $ from 'jquery';
import { handleError } from '../../services/authApiRoutes/APImethods';
import { updateCanSubmitTranslation, updateReadyForValidation } from '../../redux/reducers/AsyncAssetUploadSlice';

export default function LangaugeReferenceMaterial() {
	
	const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
	const customerBootstrapData = useSelector((reduxStore) => reduxStore.customer_bootstrap_data).value;
	const dispatch = new useDispatch();
	const [sourceLanguage, setSourceLanguage] =	useState([]);
	const [projectResource, setProjectResource] = useState({})
	const [targetLanguage, setTargetLanguage] =	useState([]);
	const [targetLanguageCount,setTargetLanguageCount]=useState([])
	const [allTargetLanguageCollection, setAllTargetLanguageCollection] = useState([]);
	const [allSourceLanguageCollection, setAllSourceLanguageCollection] = useState([]);
	const [selectedSourceLanguage, setSelectedSourceLanguage] = useState("");
	const [selectedTargetLanguageList, setSelectedTargetLanguageList] = useState([]);
	const [uiFeatures, setUiFeatures] = useState({});
	const [languageGroup,setLanguageGroup] = useState([]);
	const [languageGroupValues,setLanguageGroupValues] = useState({});
	const [refresh,setRefresh] = useState(0);
	const [tabOption,setTabOption] = useState("REFERENCE_MATERIAL");
	const validationErrors = useSelector(reduxStore => reduxStore.asset_upload_background).value.validationErrors;
	const { t } = useTranslation();
	const translate = t;
	const sourceFiles = useSelector((reduxStore) => reduxStore.source_files).value;
	function expandRightFunction() {
		var element = document.getElementById("container");
		element.classList.toggle("expand-right");
	   }    

	  const projectInfo = useSelector((reduxStore) => reduxStore.project_info).value;

	  useEffect(()=>{
        if(targetLanguage?.length > 0){
		  const filteredArray = targetLanguage?.filter(value => !projectInfo?.targetLanguages?.includes(value?.language));
		  setTargetLanguage(filteredArray)
		}
	  },[targetLanguageCount])

	  useEffect(() => {
		if(Object.keys(projectResource).length !== 0) {
			getAxiosResponse(APIUrls.SOURCE_LANGUAGE)
			.then((res) => {
				if (res.data.code === 200) {
					const sourceLang = transformBlankToNull(res.data.data);
					let options = sourceLang.map((language) => ({
						label: language.display,
						value: language.code,
						language: language.language
					}))
					setAllSourceLanguageCollection(options);
					if(projectInfo.sourceLanguage && projectInfo.targetLanguages){
						if(options.find(language => language.value === projectResource.displayName[0]["sourceLanguage"].code) === undefined) {
							options.push({
								label: projectResource.displayName[0]["sourceLanguage"].display,
								value: projectResource.displayName[0]["sourceLanguage"].code,
								language: projectResource.displayName[0]["sourceLanguage"].language
							});
						}
						setSourceLanguage(options.filter(lang => projectInfo?.sourceLanguage !== lang.language && !projectInfo.targetLanguages.includes(lang.language)));
						setSelectedSourceLanguage(options.filter(lang=>projectInfo.sourceLanguage === lang.language)[0]);
					} else {
						setSourceLanguage(options);
					}
				}
			}).catch((err) => {
				handleError(err);
			});

			getAxiosResponse(APIUrls.TARGET_LANGUAGE)
				.then((res) => {
					if (res.data.code === 200) {
						const targetLang = transformBlankToNull(res.data.data);
						let options = [{label:"--Select All--",value:"select-all",language:""}];
						targetLang.forEach((language) => {
							options.push({label: language.display, value: language.code, language: language.language, code:language.code});
						});
						setAllTargetLanguageCollection(options)
						if(projectInfo.targetLanguages && projectInfo.sourceLanguage){
							let nonExistentLanguages = projectResource.displayName[0]["targetLanguages"].filter(language => {
								return !options.some(option => option.value === language.code);
							});
							if(nonExistentLanguages.length !== 0) {
								nonExistentLanguages.forEach((language) => {
									options.push({label: language.display, value: language.code, language: language.language, code:language.code});
								})
							}
							setTargetLanguage(options.filter(lang=>!projectInfo.targetLanguages.includes(lang.language) && projectInfo.sourceLanguage !== lang.language));
							setTargetLanguageCount(options.filter(lang=>!projectInfo.targetLanguages.includes(lang.language)));
							setSelectedTargetLanguageList(options.filter(lang=>projectInfo.targetLanguages.includes(lang.language)));
						} else {
							setTargetLanguage(options);
							setTargetLanguageCount(options);
						}
						setRefresh(1);
					}
				}).catch((err) => {
				handleError(err);
				});
		}
	  }, [projectResource])

	  useEffect(()=>{
		const fetchData = async () => {
			try {
				const [projectRes, uiFeaturesRes, customerLangGroupRes] = await Promise.all([
					getAxiosResponse(APIUrls.PROJECT(projectInfo.id)),
					getAxiosResponse(APIUrls.PROJECT_UI_FEATURES(projectInfo.id)),
					getAxiosResponse(APIUrls.GET_CUSTOMER_LANGUAGE_GROUP)
				]);
		
				setProjectResource(projectRes?.data?.data);
				setUiFeatures(uiFeaturesRes.data.data);
		
				const data = customerLangGroupRes.data.data;
				if (data) {
					let values = {};
					let langGrp = [{label:translate("select_preset_label"),value:"",language:""}];
					data.forEach((o) => {
						values[o?.resource?.name] = o.displayName[0].map((o) => ({label:o.display,value:o.code,language:o.name,isSelected:false, code:o.code}));
						langGrp.unshift({label:o?.resource?.name,value:o.displayName[0][0]?.code,language:""});
					});
					setLanguageGroupValues(values);
					setLanguageGroup(langGrp);
					setRefresh(2);
				}
		
				const hasFailedValidation = validationErrors.some((validation) => validation.status === "fail" || validation.status === "error");
				if (!hasFailedValidation && sourceFiles.length !== 0) {
					dispatch(updateCanSubmitTranslation(true));
				}
			} catch (err) {
				handleError(err);
			}
		};
		fetchData();
	  },[])

	  useEffect(()=>{
		let targlang = targetLanguage;
		languageGroup.forEach((o)=>{
			targlang.unshift(o);
		})
		setTargetLanguage(targlang);
	  },[refresh]);

	  useEffect(()=>{
		if(selectedSourceLanguage === ""){
			dispatch(updateSourceLanguage({}));	
		}else{
			dispatch(updateSourceLanguage(selectedSourceLanguage));
		}		
	  },[selectedSourceLanguage]);

	  useEffect(()=>{
		dispatch(updateTargetLanguage(selectedTargetLanguageList));			 
	  },[selectedTargetLanguageList]);
	
	const clearSourceLanguage = () =>{
		let selectedTargs = selectedTargetLanguageList.map((lang) => lang.value);
		setSelectedSourceLanguage("");
		setSourceLanguage(allSourceLanguageCollection.filter(lang => !selectedTargs.includes(lang.value)));
		setTargetLanguage(allTargetLanguageCollection.filter((lang) => !selectedTargs.includes(lang.value)));
		if($(document.activeElement).is(':last-child')){
			$(document.activeElement).closest(".sourcFocus").find('.global-dropdown-select input:first-of-type').trigger('focus');
		}
	}

	const getAllSelectedLanguages = (selectedSource, selectedtarget) => {
		if(!selectedSource) {
			selectedSource = selectedSourceLanguage;
		}
		if(!selectedtarget) {
			selectedtarget = selectedTargetLanguageList;
		}
		let selectedLangs = [...selectedtarget];
		if(selectedSource) {
			selectedLangs = [...selectedLangs, selectedSource];
		}
		return selectedLangs.map((lang) => lang.value);
	}

	const updateSourceLanguageList = (selectedSource, selectedtarget) => {
		let selectedLangs = getAllSelectedLanguages(selectedSource, selectedtarget);
		let list = allSourceLanguageCollection.filter(lang => !selectedLangs.includes(lang.value))
		setSourceLanguage(list);
	}

	const updateTargetLanguageList = (selectedSource, selectedtarget) => {
        let selectedLangs = getAllSelectedLanguages(selectedSource, selectedtarget);
		let list = allTargetLanguageCollection.filter(lang => !selectedLangs.includes(lang.value))
		setTargetLanguage(list);
	}


	  const clearSourceLanguageOnKeydown = (event) => {
		if(event.key === Constants.ENTER) {
			clearSourceLanguage();
		}
	  };
     
	  const clearTargetLanguage = (language) =>{
		let flag = false;
		let lgv = languageGroupValues;
		for (const property in languageGroupValues) {
			const lgv_property = lgv[property];
			let newLgvProp = [];
			lgv_property.forEach((lang)=>{
				let newlang = {label:lang.label,value:lang.value,language:lang.language,isSelected:lang.isSelected};
				if(lang.value === language.value){
					newlang.isSelected = false;
					flag = true;
				}
				newLgvProp.push(newlang);
			});
			lgv[property] = newLgvProp;
			if(flag === true){
				break;
			}
		}
		setLanguageGroupValues(lgv);
		let langGrp = languageGroup.find(lg=>lg.value === language.value);
		if(langGrp !== undefined) {
			targetLanguage.splice(1,0,langGrp);
		}
		let selectedTargetLanguages = selectedTargetLanguageList.filter((lang)=>lang.value !== language.value)
		setSelectedTargetLanguageList(selectedTargetLanguages);
		updateTargetLanguageList(null, selectedTargetLanguages)
		let langExistsInSourceCollection = allSourceLanguageCollection.find(lang => lang.value === language.value);
		if(langExistsInSourceCollection !== undefined) {
			updateSourceLanguageList(null, selectedTargetLanguages);
		}
		const selectedElement = $(document.activeElement).closest(".multiselect-output");
		if($(document.activeElement).is(':last-child') && selectedElement.children().length > 1){
			selectedElement.find('button:nth-last-child(2)').trigger('focus');
		 }
		 else if($(document.activeElement).is(':last-child')){
		   $(document.activeElement).closest(".langFocus").find('.global-dropdown-select input:first-of-type').trigger('focus');
		 }
	  };

	  const clearTargetLanguageOnKeydown = (event, language) => {
		if(event.key === Constants.ENTER) {
			clearTargetLanguage(language);
		}
	  }

	  const handleSourceLanguageChange = (event) => {
		let selectedTargs = selectedTargetLanguageList.map((lang) => lang.value);
		selectedTargs.push(event.value);	
		setSelectedSourceLanguage(event)
		setSourceLanguage(allSourceLanguageCollection.filter((lang) => event.value !== lang.value && !selectedTargs.includes(lang.value)))
		setTargetLanguage(targetLanguage.filter((lang) => event.value !== lang.value && !selectedTargs.includes(lang.value)));
	  };

	  const handleTargetLanguageChange = (event) => {
		if(event.value === "select-all"){
			let selectedLanguage = targetLanguage.filter((lang)=>(lang.language!==""));
			setSelectedTargetLanguageList(selectedLanguage)
			setTargetLanguage([]);
		}else{
			const group = languageGroupValues[event.label];
			let filteredTargetLang = [];
			if(group){
				filteredTargetLang = targetLanguage.filter((lang)=> {
					return (group.find((gl)=>((gl.isSelected === false) && (lang.value === gl.value))) === undefined) && lang.value !== event.value;
				});
			}else{
				filteredTargetLang = targetLanguage.filter((lang)=>event.value !== lang.value && lang.value !== event.value);
			}
			setTargetLanguage(filteredTargetLang);
			if(group){
				group.forEach((lang)=>{
					if(lang.isSelected === false){
						lang.isSelected = true;
						setSelectedTargetLanguageList((selectedTargetLanguageList)=>[...selectedTargetLanguageList,lang]);
					}
				});
				let lgv = languageGroupValues;
				lgv[event.value] = group;
				setLanguageGroupValues(lgv);
			}else{
				setSelectedTargetLanguageList((selectedTargetLanguageList)=>[...selectedTargetLanguageList,event]);
			}
		}
		if(customerBootstrapData?.features?.ASSET_VALIDATION) {
			dispatch(updateReadyForValidation(true));
		}
		let selectedTargs = selectedTargetLanguageList.map((lang) => lang.value);
		selectedTargs.push(event.value);
		setSourceLanguage(sourceLanguage.filter((lang) => lang.value !== event.value && !selectedTargs.includes(lang.value)))
	   };
	
    return (

        
            <div className="flex">
			 <div className="w-d100">
			  <div className="success-message hide">
                <span>you file is are validated &amp; uploaded successfully</span>
				<a href="#">View Files</a>
				<button className="cross">
					<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
						<path d="M6.57812 6.90625L13.048 13.0938M13.048 6.90625L6.57812 13.0938L13.048 6.90625Z" stroke="#2A4274" strokeWidth="1.5" strokeLinecap="round" ></path>
						<path d="M9.81402 18.5938C14.7768 18.5938 18.7999 14.7462 18.7999 10C18.7999 5.2538 14.7768 1.40625 9.81402 1.40625C4.85125 1.40625 0.828125 5.2538 0.828125 10C0.828125 14.7462 4.85125 18.5938 9.81402 18.5938Z" stroke="#2A4274" strokeWidth="1.5" strokeLinecap="round"></path>
					</svg>
				</button>
			  </div>
			  <div className="step-2-section">
				<h3>{translate("project_listing.select_language")} </h3>
				<div className="flex wrap-dropdown" createproject-tour="target-lang">
					<div className="global-dropdown-block flex-center sourcFocus">
						<label>{translate("project_listing.source_language")}</label>
						{uiFeatures?.CHANGE_SOURCE_LANGUAGE	?					
						(<><div className="global-dropdown-select">						   
							<Select
								className="global-dropdown-select requiredInput" classNamePrefix='cw'
								name="Source Language"
								aria-label="Source Language"
								placeholder="Select"
								options={sourceLanguage}
								onChange={(event) => handleSourceLanguageChange(event)}
								value={{
									label: translate("project_listing.select"),

									value: ""
								}}
							>
							</Select>
						</div>
						<div className="multiselect-output flex">
							{selectedSourceLanguage && <button aria-label={'remove ' + selectedSourceLanguage.label} onClick={clearSourceLanguage} onKeyDown={(e)=>clearSourceLanguageOnKeydown(e)}>
								<strong>{selectedSourceLanguage.label}</strong>
								<svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
									<path d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
								</svg>
						  	</button>}
						</div></>) :
						<div className="multiselect-output flex">
							{selectedSourceLanguage && 
							<button aria-label={'remove ' + selectedSourceLanguage.label}> <strong>{selectedSourceLanguage.label}</strong> </button>}
						</div>
							}
					 </div>
					 <div className="cust-arrow"></div>
					 <div className="global-dropdown-block flex-center langFocus">
						<label>{translate("project_listing.translate_into")}</label>
						{uiFeatures?.CHANGE_TARGET_LANGUAGES ? 
						(<><div className="global-dropdown-select">
							<Select
								className="global-dropdown-select requiredInput" classNamePrefix='cw'
								name="Target Language"
								aria-label="Target Language"
								placeholder="Select"
								options={targetLanguage}
								onChange={(event) => handleTargetLanguageChange(event)}
								value={{
									label: translate("project_listing.select"),
									value: ""
								}}
							>
							</Select>
						</div>
						<div className="multiselect-output flex">
							{selectedTargetLanguageList &&
								selectedTargetLanguageList.map(targetLanguage => (
									<button aria-label={'remove ' + targetLanguage.label} onClick={(e) => clearTargetLanguage(targetLanguage)} onKeyDown={(e) => clearTargetLanguageOnKeydown(targetLanguage)}>
										<strong>{targetLanguage.label}</strong>
										<svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
											<path d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
										</svg>
									</button>
								)
								)
							}
						</div></>) :
						<div className="multiselect-output flex">
							{selectedTargetLanguageList &&
								selectedTargetLanguageList.map(targetLanguage => (
									<button aria-label={'remove ' + targetLanguage.label}><strong>{targetLanguage.label}</strong></button>
								))}
						</div>
					}
					 </div>
				</div>
				<div className="materials-tab">
					<div className="listing-tab-block flex">
						<ul className="listing-tab-link flex" role="tablist">
						  <li role="none">
							<button className={tabOption === "REFERENCE_MATERIAL" ? "active" : ""} onClick={()=>setTabOption("REFERENCE_MATERIAL")}
						    role="tab"
							aria-label={translate("project_listing.reference_materials")}
							aria-selected="true"    
						  >
							{translate("project_listing.reference_materials")}</button>
						  </li>
						  <li role="none">
							<button className={tabOption === "TRANSLATION_MATERIAL" ? "active" : ""} onClick={()=>setTabOption("TRANSLATION_MATERIAL")}
						    role="tab"
							aria-label="Translation Materials"
							aria-selected="true"    
						  >
							Translation Materials
							</button>
						  </li>
						</ul>
					 </div>
					 <div className={tabOption === "REFERENCE_MATERIAL" ? "materials-tab-content flex" : "materials-tab-content flex hide"}>
						<ReferenceMaterialUpload/>
					</div>
					<div className={tabOption === "TRANSLATION_MATERIAL" ? "materials-tab-content flex" : "materials-tab-content flex hide"}>
						<TranslationMemorySelection projectId={projectInfo.id}/>
					</div>
				</div>
			  </div>
				
			 </div>
			 
			</div>        
    )
    
};
